import { useContext, useEffect, useState } from 'react';
import { Config, TollRegistrationContext, TollReliefScheme } from 'src/context/ApplicationContext';
import { getConfigsApi } from '../services/api-services';
import { useHistory } from 'react-router-dom';
import routes from 'src/routes';
import { isErrorRedirect } from 'src/services/httpClient/responseInterceptor';

function useTrConfig() {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const {
        configs,
        setConfigs,
    } = useContext(TollRegistrationContext);
    const history = useHistory();

    useEffect(() => {
        const apiCall = async () => {
            const configsResponse = await getConfigsApi();
            setConfigs(configsResponse);
            setIsLoading(false);
        }

        try {
            if (!Array.isArray(configs) || configs.length < 1) {
                apiCall();
            } else {
                setIsLoading(false);
            }
        } catch (error: any) {
            if (isErrorRedirect(error)) {
                console.error(`get configs api call failed: ${error.statusText}`);
                history.push(error.redirect);
            } else {
                console.error(`get configs api call failed: ${error}`);
                history.push(routes.errorPage.path);
            }
        }

    }, []);

    let selected: Config;

    const selectScheme = (scheme: TollReliefScheme) => {
        if (!configs) {
            return null;
        }

        const foundConfig = configs.find(it => it.scheme === scheme);
        if (!foundConfig) {
            return null;
        }

        selected = foundConfig;

        return helper;
    }

    const getAttribute = (key: string) => {
        if (!selected || !selected.schemeDetails[key]) {
            return null;
        }

        return selected.schemeDetails[key] as string
    }

    const helper = {
        isLoading,
        /**
         * select config based on TollReliefScheme type
         */
        selectScheme,
        /**
         * get SchemeDetails attribute as string from the seleted config
         */
        getAttribute,
        /**
         * TR3 helper to get weeklyCap; Produce something like '$60'
         */
        getTR3weeklyCap: () => `$${selectScheme(TollReliefScheme.TR3)?.getAttribute('weeklyCap') || ''}`,
        /**
         * TR3 helper to get tagRebateCap; Produce something like '$340'
         */
        getTR3tagRebateCap: () => `$${selectScheme(TollReliefScheme.TR3)?.getAttribute('tagRebateCap') || ''}`,
    }

    return helper;
}

export default useTrConfig;
